<template>
  <div class="flex flex-col gap-4">
    <div v-for="(option, index) in modelValue" :key="index">
      <InfuseRadioButton
        group-name="radio-gaga"
        :model-value="selectedOption"
        :value="option.name"
        :label="option.label()"
        @update:model-value="(newValue) => optionChanged(newValue, option)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { FilterOption } from '@infuse/ui/domain';
import { onMounted, Ref, ref } from 'vue';
import { InfuseRadioButton } from '../../index';

interface Props {
  modelValue: FilterOption[];
}

const props = withDefaults(defineProps<Props>(), {});

interface Emits {
  (e: 'apply:value', value: FilterOption): void;

  (e: 'validationChange', valid: boolean): void;
}

const emit = defineEmits<Emits>();

const selectedOption: Ref<string> = ref('');

onMounted(() => {
  const defaultOption = props.modelValue[0];
  selectedOption.value = defaultOption.name;

  optionChanged(selectedOption.value, defaultOption);
});

function optionChanged(newValue: string, option: FilterOption): void {
  selectedOption.value = newValue;

  emit('apply:value', option);
  emit('validationChange', !!selectedOption.value);
}
</script>
